<script>
import { mapGetters } from "vuex";
import { i18n } from "@v2/shared/config";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    currentYear() {
      return new Date().getFullYear();
    },
    locale() {
      return i18n.locale;
    }
  }
};
</script>

<template>
  <div class="app-footer">
    <div class="container" :class="{ 'container-un__auth': !isAuthenticated }">
      <div class="app-footer__copyright">
        © {{ $t("common.expoBrandName") }} {{ currentYear }}
      </div>
      <div class="app-footer__email">
        <a href="mailto:suplk@expocentr.ru" class="app-footer__email-link">
          suplk@expocentr.ru
        </a>
      </div>
      <div class="app-footer__policy">
        <a
          class="app-footer__phone-link"
          target="_blank"
          :href="
            `https://www.expocentr.ru/upload/docs/Expocentre_personal_data_processing_policy_${locale}.pdf`
          "
        >
          {{ $t("common.footer.privatePolicy") }}</a
        >
      </div>
      <div class="app-footer__phone">
        <a href="tel:88007073799" class="app-footer__phone-link">
          8 800 707-37-99
        </a>
        <small class="app-footer__phone-hint">
          {{ $t("common.footer.helplineOpenHours") }}
        </small>
      </div>

      <div class="app-footer__callback" v-if="isAuthenticated">
        <button
          class="app-footer__callback-link"
          @click="$modal.show('feedback-modal', { phone: true })"
        >
          {{ $t("common.footer.callbackRequest") }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.app-footer {
  background: #f1f1f1;

  @include respond-down(md) {
    padding: 17px 0;
  }

  .container {
    display: flex;
    align-items: center;
    min-height: 64px;
    &-un__auth {
      justify-content: space-between;
      & .app-footer__phone {
        margin-right: 0;
      }
    }

    @include respond-down(md) {
      flex-wrap: wrap;

      > * {
        flex: 1 0 50%;
        margin-right: auto;
      }
    }
  }

  &__copyright {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    color: #a3a8b3;
    text-transform: uppercase;
    margin-right: 39px;

    @include respond-down(md) {
      order: 1;
      align-self: flex-start;
    }
  }

  &__email {
    margin-top: 2px;
    margin-right: 62px;

    &-link {
      @include hyperlink();
      font-size: 12px;
    }

    @include respond-down(md) {
      order: 3;
    }
  }
  &__policy {
    max-width: 250px;
    margin-right: auto;
    @include respond-down(lg) {
      max-width: 200px;
    }
    @include respond-down(md) {
      max-width: none;
      margin-bottom: 15px;
    }
    & .app-footer__phone-link {
      @include hyperlink();
      font-size: 12px;
    }
  }
  &__phone {
    margin-right: auto;

    &-link {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      color: #55575a;
      text-decoration: none;
      margin-right: 11px;
    }

    &-hint {
      font-size: 10px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #a3a8b3;
      display: block;
    }

    @include respond-down(md) {
      order: 2;
      align-self: flex-start;
    }
  }

  &__callback {
    &-link {
      @include button-clean();
      @include hyperlink();

      font-size: 12px;
    }

    @include respond-down(md) {
      order: 4;
    }
  }
}
</style>
